import React from 'react'
import { largeWowheadUrl, WowheadIconNames } from 'web/data/icons'

type GameIconProps = {
    size: string
    className?: string
    tooltip?: string
    icon_name?: string
    style?: React.CSSProperties
}

export const GameIcon: React.FC<GameIconProps> = (props) => {

    let extraZoom: boolean = false

    const fixUrls = [
        'spell_nature_tranquility',
        'spell_holy_powerwordbarrier',
        'spell_holy_divinehymn',
        'ability_druid_improvedtreeform',
        'spell_nature_reincarnation',
        'spell_fire_elementaldevastation',
    ]

    // Boost zoom on old icons with heavy black borders
    if (fixUrls.includes(props.icon_name ?? '')) {
        extraZoom = true
    }

    const iconUrl = (props.icon_name != null)
        ? largeWowheadUrl(props.icon_name)
        : largeWowheadUrl(WowheadIconNames.questionMark)

    return (
        <div
            // TODO: This is a stupid design, lift it up
            data-tip={props.tooltip}

            className={props.className}
            style={{
                width: props.size,
                height: props.size,

                backgroundImage: `url(${iconUrl})`,
                backgroundPosition: "center",
                backgroundSize: (extraZoom) ? "115%" : "100%",

                ...props.style
            }}
        />
    )
}
